import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import SystemAlert from "../common/SystemAlert";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrnDetails from "../grid/ViewDataGridGrnDetails";
import ViewGrnSupplier from "./ViewGrnSupplier";
import ViewGrnPo from "./ViewGrnPo";
import ViewGrnAttachments from "./ViewGrnAttachments";
import ViewGrnBillInfo from "./ViewGrnBillInfo";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import GrnStatusHistory from "./GrnStatusHistory";
// @ts-ignore
import GrnPdf from "../../features/documents/GrnPdf";
// @ts-ignore
import RejectionNotePdf from "../../features/documents/RejectionNotePdf";
// @ts-ignore
import ReturnNotePdf from "../../features/documents/ReturnNotePdf";
// @ts-ignore
import DebitNotePdf from "../../features/documents/DebitNotePdf";
import ViewGrnReturnInfo from "./ViewGrnReturnInfo";
import { AnyForNow, GrnData, GrnItem } from "../../features/grn/types";
import { useGrnDetailLayout } from "../../features/grn/hooks/useGrnDetailLayout";
import { GRN_VIEW_DETAIL } from "../../utils/sys/GrnConstants";
import ViewReturnGrnPro from "./ViewReturnGrnPo";
import GrnReturnStatusHistory from "./GrnReturnStatusHistory";
import ViewDataGridGrnDetailstable from "../grid/ViewDataGridGrnDetailstable";
import ViewGrnRtnappSupplier from "./ViewRtnappSupplier";

// ============================================
interface ViewDetailGrnBodyProps {
  statusCode?: string | number;
  grnItems?: GrnItem[] | AnyForNow;
  selectedSupplier?: AnyForNow;
  grnDetailsForm?: AnyForNow;
  attachments?: AnyForNow;
  grnHeader?: AnyForNow;
  grncode?: string;
  trackingDetails?: AnyForNow;
  grnstatuscode?: string | number;
  grnDocuments?: AnyForNow;
  grnReturns?: AnyForNow;
  grnPaySummery?: AnyForNow[];
  grnPayTax?: AnyForNow[];
  grnData?: GrnData | AnyForNow;
  totalGross?: number | string;
  taxValues?: AnyForNow;
  grnTaxTypes?: AnyForNow[];
  grnCompany?: AnyForNow;
  grncharges?: AnyForNow[];
  origin?: string;
  addedCharges?: AnyForNow[];
  grnReturnList?: AnyForNow[];
  grnReturnMaster?: AnyForNow[];
  grnRejectList?: AnyForNow[];
  otherchargevalue?: AnyForNow[];
  processResponse?: AnyForNow[];
  grncal?: AnyForNow;
  calSummary?: AnyForNow;
  trsts?: AnyForNow;
    grnreturncode?: string;
    returneddate?: string;
    page?: string;
}

const ViewDetailRtnGrnBody: React.FC<ViewDetailGrnBodyProps> = ({
  statusCode,
  grnItems,
  selectedSupplier,
  grnDetailsForm,
  attachments,
  grnHeader,
  grncode,
  trackingDetails,
  grnstatuscode,
  grnDocuments,
  grnReturns,
  grnPaySummery,
  grnPayTax,
  grnData,
  totalGross,
  taxValues,
  grnTaxTypes,
  grnCompany,
  grncharges,
  origin,
  addedCharges,
  grnReturnList,
  grnReturnMaster,
  grnRejectList,
  otherchargevalue,
  processResponse,
  grncal,
  calSummary
    ,grnreturncode
    ,returneddate
}) => {
  const normalizedStatusCode =
    statusCode === undefined || statusCode === null ? "" : String(statusCode);
  console.log("ViewDetailGrnBody processResponse:", processResponse);
  const theme = useTheme();
  const styles = useStyles(theme);
  const { setPageData } = useContext(PageDataContext);
  const {
    rightSidebarRef,
    rightSidebarOpen,
    toggleRightSidebar,
    docType,
    openPdf,
    setOpenPdf,
    handleOpenPdf,
  } = useGrnDetailLayout();
  const [alert, setAlert] = useState<{
    open: boolean;
    type: string;
    message: string;
  }>({
    open: false,
    type: "success",
    message: "",
  });
  // Toggle function handled via hook
  useEffect(() => {
    setPageData({
      title: "Purchases Return Approvals",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const handleAlertClose = () => {
    setAlert({ ...alert, open: false });
  };

  console.log("grncode", grncode);
  console.log("statuscode", statusCode);

  return (
    <>
      <Box
        ref={rightSidebarRef}
        sx={{
          position: "fixed",
          top: 64,
          right: rightSidebarOpen ? 0 : "-320px",
          width: { xs: "80vw", sm: 320 },
          height: "100vh",
          bgcolor: "background.paper",
          boxShadow: 3,
          p: 1,
          zIndex: 1,
          transition: "right 0.3s ease-in-out",
          pointerEvents: "auto", // sidebar accepts pointer events
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          scrollbarWidth: "none", // Hide scrollbar in Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",

            alignItems: "center",
            my: 1,
          }}
        >
          <Typography variant="h6">GRN Tracking</Typography>
          <IconButton
            onClick={toggleRightSidebar}
            size="small"
            aria-label="close sidebar"
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers
            },
          }}
        >
          <GrnStatusHistory
            trackingDetails={trackingDetails}
            grncode={grncode}
          />
        </Box>
      </Box>
      <Box sx={styles.grn_supplier_container}>
        <Grid container spacing={2}>
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={styles.title_text}>
              {/* {(GRN_VIEW_DETAIL.HOLD_LIKE_STATUSES as readonly string[]).includes(String(statusCode))
                ? "Hold GRN"
                : grncode
                ? `GRN : ${grncode}`
                : "Submit GRN"} */}

              {/* {grncode ? `GRN : ${grncode}` : "Submit GRN"} */}
              Return ID : {grnreturncode || "N/A"}
            </Typography>

            <Tooltip title="View History">
              <IconButton
                onClick={toggleRightSidebar}
                disabled={statusCode === 3}
              >
                <ViewSidebarOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Divider />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
              }}
            >
              <ViewGrnRtnappSupplier
                onOpenSidebar={toggleRightSidebar}
                selectedSupplier={selectedSupplier}
              statusCode={statusCode} 
                grnHeader={grnHeader}
                grncode={grncode}
                grnstatuscode={grnstatuscode}
                origin ={origin}
               
               
              />
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            sx={{
              width: "50%",
              display: "flex",
              justifyItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
                display: "flex",
                justifyItems: "flex-end",
              }}
            >
              <ViewReturnGrnPro
                grnDetailsForm={grnDetailsForm}
                grnHeader={grnHeader}
                grnreturncode={grnreturncode}
                returneddate={returneddate}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <ViewDataGridGrnDetailstable
          grnItems={grnItems}
          grnDocuments={grnDocuments}
          grnReturns={grnReturns}
          grnRejectList={grnRejectList}
          grnReturnList={grnReturnList}
          grnData={grnData}
          origin={origin}
            grnreturncode={grnreturncode}
                 grnHeader={grnHeader}
        />
      </Box>

      {/* Attachenments and price */}

      <Box pt={2} sx={styles.grn_search_container}>
        <Grid container spacing={6}>
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            {/* <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Attached Documents:
            </Typography>
            <Divider />
            <ViewGrnAttachments
              attachments={attachments}
              grnData={grnData}
              grnDocuments={grnDocuments}
            /> */}
          </Grid>
             {!["9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
             Financial Information
            </Typography>
            <Divider />
            <ViewGrnBillInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
              grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
           grncharges={grncharges}
           addedCharges={addedCharges}
              origin ={origin}
         otherchargevalue={otherchargevalue}
         processResponse={processResponse}
         calSummary={calSummary}
         
         grncal={grncal}
            />
          </Grid>
          ) : null}

               {["9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
             Financial Information
            </Typography>
            <Divider />
            <ViewGrnReturnInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
              grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
          grncharges={grncharges}
           grnreturncode={grnreturncode}
          addedCharges={addedCharges}
             origin ={origin}
             grnReturns={grnReturns}
              grnItems={grnItems}
              grnReturnList={grnReturnList}
              grnReturnMaster={grnReturnMaster}
                   processResponse={processResponse}
            />
          </Grid>
          ) : null}
      
       
          {origin !== "CreateGrn" && origin !== "EditGrn" && (
            <Grid
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Divider />
             {!["7","8","9", "10", "11", "12","13"].includes(normalizedStatusCode) ? (
                <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ ...styles.btn_primary }}
                onClick={() => handleOpenPdf("Good Received Note")}
              >
                View GRN Note
              </Button>
              ): null}

               {[ "10", "11", "12","13"].includes(normalizedStatusCode) ? (
                 <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Debit Note")}
                >
                View Debit Note
                </Button>
              ): null}
             
            {[ "10", "11", "12","13"].includes(normalizedStatusCode) ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Return Note")}
                >
                  View Return Note
                </Button>
             ) : !["7","8", "9"].includes(normalizedStatusCode) ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Rejection Note")}
                >
                  View Reject Note
                </Button>
              ): null}



            </Grid>
          )}
        </Grid>
      </Box>
    

      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {docType} Preview
          <IconButton
            aria-label="close"
            onClick={() => setOpenPdf(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {docType === "Return Note" ? (
            <ReturnNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnReturns={grnReturns}
              grnData={grnData}
              grnCompany={grnCompany}
              grnReturnList={grnReturnList}
              grnReturnMaster={grnReturnMaster}
              returnedProducts={grnReturnList}
              grnreturncode={grnreturncode}
                 
            />
          ) : docType === "Rejection Note" ? (
            <RejectionNotePdf
              grnHeader={grnHeader}
              docType={docType}
              grnItems={grnItems}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnData={grnData}
              grnReturns={grnReturns}
              grnRejectList={grnRejectList}
              grnCompany={grnCompany}
                
            />
          ) : docType === "Debit Note" ? (
            <DebitNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnReturns={grnReturns}
              grnData={grnData}
              grnCompany={grnCompany}
              grnReturnList={grnReturnList}
              grnReturnMaster={grnReturnMaster}
              returnedProducts={grnReturnList}
                 grnreturncode={grnreturncode}  
            />)
          
          
          : (
            <GrnPdf
              docType={docType}
              grnHeader={grnHeader}
              grnItems={grnItems}
              selectedSupplier={selectedSupplier}
              grnPaySummery={grnPaySummery}
              grnData={grnData}
              grnDetailsForm={grnDetailsForm}
               grnRejectList={grnRejectList}
              grnCompany={grnCompany}
          grnReturns={grnReturns}
            />
          )}
        </DialogContent>
      </Dialog>

      <SystemAlert
        open={alert.open}
        type={alert.type}
        message={alert.message}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default ViewDetailRtnGrnBody;
